import { createActionGroup, emptyProps, props } from '@ngrx/store';
import { ContentBlock } from '../models';

export const contentBlockActions = createActionGroup({
    events: {
        'Get Content Block': props<{ id: string }>(),
        'Get Content Block Success': props<{ id: string; blocks: ContentBlock[] }>(),
        'Get Content Block Error': props<{ id: string }>(),
        clear: emptyProps(),
    },
    source: 'Content Block',
});
